module.exports = __webpack_public_path__ + "static/media/members.3c6f7caf.svg";